document.addEventListener('DOMContentLoaded', function() {
  // Wait for custom elements to be defined
  customElements.whenDefined('header-menu').then(() => {
    // Get all header-menu elements with hover enabled class
    const headerMenus = document.querySelectorAll('header-menu.hover-enabled-menu');
    
    headerMenus.forEach(headerMenu => {
      const details = headerMenu.querySelector('details');
      if (!details) return;
      
      // Only apply hover on devices that support it
      if (window.matchMedia('(hover: hover)').matches) {
        // Add hover behavior
        headerMenu.addEventListener('mouseenter', () => {
          if (!details.hasAttribute('open')) {
            details.setAttribute('open', '');
          }
        });
        
        headerMenu.addEventListener('mouseleave', () => {
          // Only auto-close if we're not focused within the menu
          if (!headerMenu.contains(document.activeElement)) {
            // Use the close method if available, or just remove the open attribute
            if (typeof headerMenu.close === 'function') {
              headerMenu.close();
            } else {
              details.removeAttribute('open');
            }
          }
        });
        
        // Handle clicks on the menu links
        const menuLink = details.querySelector('summary a.menu-link');
        if (menuLink) {
          menuLink.addEventListener('click', (e) => {
            // Let the link do its natural navigation
            e.stopPropagation();
          });
        }
        
        // Handle clicks on the icon separately
        const iconContainer = details.querySelector('summary .icon-container');
        if (iconContainer) {
          iconContainer.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            
            if (details.hasAttribute('open')) {
              if (typeof headerMenu.close === 'function') {
                headerMenu.close();
              } else {
                details.removeAttribute('open');
              }
            } else {
              details.setAttribute('open', '');
            }
          });
        }
      }
    });
    
    // Handle submenus
    const subMenuDetails = document.querySelectorAll('header-menu.hover-enabled-menu details summary + ul details');
    if (window.matchMedia('(hover: hover)').matches) {
      subMenuDetails.forEach(subDetails => {
        const subMenuContainer = subDetails.closest('li');
        if (!subMenuContainer) return;
        
        // Add hover behavior to submenu
        subMenuContainer.addEventListener('mouseenter', () => {
          if (!subDetails.hasAttribute('open')) {
            subDetails.setAttribute('open', '');
          }
        });
        
        subMenuContainer.addEventListener('mouseleave', () => {
          if (!subMenuContainer.contains(document.activeElement)) {
            subDetails.removeAttribute('open');
          }
        });
        
        // Make submenu links clickable
        const subMenuLink = subDetails.querySelector('summary a.menu-link');
        if (subMenuLink) {
          subMenuLink.addEventListener('click', (e) => {
            e.stopPropagation();
          });
        }
      });
    }
  });

  // Make mobile menu parent links clickable
  const mobileMenuLinks = document.querySelectorAll('.mobile-menu-link');
  
  mobileMenuLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      // Stop the click from toggling the dropdown
      e.stopPropagation();
    });
  });
  
});